

































































































import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { DataApi } from './models/Add.model';
import { fetchAdd } from './fetchAdd';
import AddEquipo from './AddEquipos.vue';
import MenuItem from '@/components/MenuItem.vue';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    GridComponent: AgGridVue,
    DatePicker,
    AddEquipo,
    MenuItem,
    Confirmation,
  },
})
export default class AddModalGenerarRecepcion extends Vue {
  @Prop({ required: true, default: true }) dialog!: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  fieldEmpty: boolean = false;
  dialogPopUp: boolean = false;
  users: any = [];

  objParam: {
    recepcionador?: string;
    fecha_recepcionador?: moment.Moment;
  } = {};
  timeout: { timeout: number } = { timeout: 3000 };

  validateFieldDisabled: Record<string, boolean> = {
    recepcionado_por: false,
    fecha_recepcion: false,
    button: false,
  };

  readonly $snotify: Snotify = null;
  readonly loadingService: LoadingService = new LoadingService();

  async mounted() {
    await this.getUser();
    console.log(this.data);
    this.objParam = {
      recepcionador: this.data.recepcionado_por
        ? this.data.recepcionado_por
        : '',
      fecha_recepcionador: this.data.fecha_recepcion
        ? moment(this.data.fecha_recepcion)
        : moment(),
    };
    this.validateFieldDisabled.fecha_recepcion = !!this.data.fecha_recepcion;
    this.validateFieldDisabled.recepcionado_por = !!this.data.recepcionado_por;
    const estado_conecta: string = this.data.estado_conecta
      ? this.data.estado_conecta.toLocaleLowerCase()
      : '';

    if (
      estado_conecta === 'recibida' ||
      (this.validateFieldDisabled.fecha_recepcion &&
        this.validateFieldDisabled.recepcionado_por)
    ) {
      this.validateFieldDisabled.button = true;
    }
  }

  handleInpurtErrors() {
    this.fieldEmpty = this.objParam.recepcionador ? false : true;
  }

  handleUpdate(): void {
    if (!this.objParam.recepcionador) {
      this.fieldEmpty = true;
      this.$snotify.error('El campo Recepcionado Por es un campo obligatorio', {
        ...this.timeout,
      });
      return;
    }
    this.addReception();
  }

  handleClosed({ reload = false }): void {
    this.$emit('cerrar', reload);
  }

  handlePopUp(): void {
    if (this.validateFieldDisabled.button) {
      this.handleClosed({});
      return;
    }
    this.dialogPopUp = true;
  }

  showPopuP(confirmation: boolean): void {
    this.dialogPopUp = !this.dialogPopUp;
    if (confirmation) {
      this.handleClosed({});
    }
  }

  cerrarModal({ reload = false }): void {
    this.$emit('cerrar'), reload;
  }

  async getUser() {
    const userId = JSON.parse(
      window.localStorage.getItem('user').replace(/'/g, '"')
    ).id;

    try {
      this.loadingService.showLoading(null, 'getUser');
      const result = await fetchAdd({
        endpoint: 'get_user_all',
        body: { user_id: userId, add: this.data.nombre_add },
      });
      const {
        MENSAJE_RESPUESTA,
        CODIGO_RESPUESTA,
        USERS,
        PROPIETARIO,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { ...this.timeout });
        return;
      }
      //this.objParam.despachador = USER[0].nombre;
      this.users = USERS;
    } catch (error) {
      console.error('Error validando el usaurio: ', error);
    } finally {
      this.loadingService.hideLoading('getUser');
    }
  }

  async addReception(): Promise<void> {
    this.loadingService.showLoading();
    const self = this;
    const userId = JSON.parse(
      window.localStorage.getItem('user').replace(/'/g, '"')
    ).id;
    const clienteDefecto = window.localStorage.getItem('clienteDefecto');
    const newReception = {
      usuarioid: userId,
      usuariorut: clienteDefecto,
      estado_conecta: this.data.estado_conecta,
      nombre_add: this.data.nombre_add,
      id_add: this.data.id,
      ...self.objParam,
    };

    return await fetchAdd({
      endpoint: 'add_reception',
      body: { ...newReception },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        self.$snotify.success(MENSAJE_RESPUESTA, { ...self.timeout });
        self.handleClosed({ reload: true });
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { ...self.timeout });
          return;
        }
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { ...self.timeout }
        );
      })
      .finally(() => self.loadingService.hideLoading());
  }
}
